(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/result/result-country.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/result/result-country.js');

'use strict';

const {
  Card,
  CardBody
} = svs.ui.ReactCard;
const {
  Loader
} = svs.components.ReactLoader;
const ResultChart = svs.grassroots.components.result.ResultChart;
const ErrorDialog = svs.grassroots.components.ErrorDialog;
const {
  grassrootsQueryApi
} = svs.grassroots.store;
const ResultCountry = _ref => {
  var _response$data;
  let {
    cms
  } = _ref;
  const response = grassrootsQueryApi.useFetchResultCountryQuery(cms.year);
  const getChartDataProvinces = () => ({
    categories: response.data.record.provinces.map(province => province.name),
    values: response.data.record.provinces.map(province => province.amount)
  });
  const getChartDataSports = () => ({
    categories: response.data.record.sports.map(sport => sport.name),
    values: response.data.record.sports.map(sport => sport.amount)
  });
  const getChartDataReceivers = () => ({
    categories: response.data.record.receivers.map(receiver => receiver.name),
    values: response.data.record.receivers.map(receiver => receiver.amount)
  });
  if (response.isLoading || response.isFetching) {
    return React.createElement(Loader, {
      size: 300
    });
  }
  if (response.isError || !(response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.record)) {
    return React.createElement(ErrorDialog, null);
  }
  if (response.isSuccess) {
    return React.createElement("div", {
      className: "margin-top-1"
    }, React.createElement(Card, {
      branding: svs.grassroots.tenant,
      className: "result-total-amount"
    }, React.createElement(CardBody, null, React.createElement("h4", null, cms.countryResult.payoutHeading), React.createElement("h1", null, response.data.record.amount.toLocaleString('sv-SE'), ' ', "kr"))), React.createElement(Card, {
      branding: svs.grassroots.tenant,
      className: "margin-top-1"
    }, React.createElement(CardBody, null, React.createElement(ResultChart, {
      barHeight: "700",
      data: getChartDataProvinces(),
      title: cms.countryResult.payoutByProvinceHeading
    }))), React.createElement(Card, {
      branding: svs.grassroots.tenant,
      className: "margin-top-1"
    }, React.createElement(CardBody, null, React.createElement(ResultChart, {
      barHeight: "450",
      data: getChartDataReceivers(),
      title: cms.countryResult.payoutByReceiverHeading
    }))), React.createElement(Card, {
      branding: svs.grassroots.tenant,
      className: "margin-top-1"
    }, React.createElement(CardBody, null, React.createElement(ResultChart, {
      barHeight: "350",
      data: getChartDataSports(),
      title: cms.countryResult.payoutBySportHeading
    }))));
  }
  return React.createElement(ErrorDialog, null);
};
svs.grassroots.components.result.ResultCountry = ResultCountry;

 })(window);